export default __webpack_public_path__ + "static/media/latest-news-img33.b7e4ebe2.jpg";